import { Column } from "../objects/column";
import { DepartureAirportFormType } from "../objects/departureAirportForm";
import { DepartureAirportListConfiguration, DepartureAirportListFiltersCriteria } from "../objects/departureAirportTypeList";
import { DepartureAirportListCriteria } from "../objects/departureAirportTypeList";

export const EMPTY_DEPARTURE_AIRPORT: DepartureAirportFormType = {
    name: '',
    localization: [],
    airports: [],
    name_locales: {}
};

export const EMPTY_DEPARTURE_AIRPORT_FILTERS: DepartureAirportListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION"
};

export const EMPTY_DEPARTURE_AIRPORT_LIST_CRITERIA: DepartureAirportListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_DEPARTURE_AIRPORT_FILTERS,
    search: '',
};


export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'airports',
    field_name: 'AIRPORTS',
    checked: true,
    order_by: 'airports',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_DEPARTURE_AIRPORT_LIST_CONFIGURATION: DepartureAirportListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const DEPARTURE_AIRPORT_MODULE = 'DEPARTURE_AIRPORT';
